import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { LitPage } from '../lit-page';
import '../luna-icon/luna-icon';

@customElement('luna-back-chip')
export class LunaBackChip extends LitPage {
  content() {
    return html`
      <button type="button" class="luna-back-chip">
        <luna-icon name="arrow-back" size="22" aria-hidden="true"></luna-icon>
        <!-- No slot fallback: light-DOM distribution appends into the slot, so
             a "Back" fallback would concatenate with the supplied label. The
             shell always provides one. -->
        <span class="luna-back-chip__label mbw-type-label-back-chip"><slot></slot></span>
      </button>
    `;
  }

  styles() {
    return css`
      .luna-back-chip {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        min-width: 120px; /* pinned: figma Back Chip — grows to fit longer labels */
        height: var(--mbw-size-backchip-h);
        box-sizing: border-box;
        padding: 0 20px 0 16px; /* pinned: figma Back Chip */
        border: none;
        border-radius: var(--luna-radius-btn);
        cursor: pointer;
        color: var(--luna-edge-blue);
        background-image: linear-gradient(180deg, #ffffff 0%, #eaf1fb 100%); /* pinned: figma Back Chip */
        box-shadow: inset 0 1px 0 #ffffff, 0 3px 0 var(--luna-edge-blue);
      }

      .luna-back-chip:hover {
        background-image: linear-gradient(rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.03)),
          linear-gradient(180deg, #ffffff 0%, #eaf1fb 100%);
      }

      .luna-back-chip:active {
        box-shadow: inset 0 1px 0 #ffffff, 0 1px 0 var(--luna-edge-blue);
      }

      .luna-back-chip:focus-visible {
        outline: none;
        box-shadow:
          inset 0 1px 0 #ffffff,
          0 3px 0 var(--luna-edge-blue),
          0 0 0 5px #ffffff,
          0 0 0 7px var(--cds-focus);
      }

      .luna-back-chip__label {
        color: inherit;
      }
    `;
  }
}
